import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleBarChart } from '@carbon/charts-react';
import { useMoney } from 'src/hooks/useMoney';
import { useBranches } from 'src/hooks/useRestaurantBranches';
import { useChartTheme } from './useChartTheme';

interface BranchStockComparisonProps {
  stockValueByBranch: Array<{ branchId: string; value: number }>;
}

const BranchStockComparison = React.memo((props: BranchStockComparisonProps) => {
  const { t } = useTranslation('dashboard');
  const chartTheme = useChartTheme();
  const { format, formatCompact } = useMoney();
  const { data: branches } = useBranches();
  const branchNames =
    branches?.data?.reduce(
      (acc, branch) => Object.assign(acc, { [branch.id]: branch.name }),
      {} as Record<string, string>
    ) || {};
  return (
    <div className="dashboard__stat_widget">
      <SimpleBarChart
        data={props.stockValueByBranch.map((row) => ({
          group: branchNames[row.branchId] || row.branchId,
          value: row.value ?? 0,
        }))}
        options={{
          title: t('branchStockComparison'),
          axes: {
            left: { title: t('stockValue'), mapsTo: 'value', ticks: { formatter: (value) => formatCompact(value) } },
            bottom: { mapsTo: 'group', scaleType: 'labels' as any },
          },
          tooltip: { valueFormatter: (value) => format(value) },
          height: '400px',
          theme: chartTheme,
        }}
      />
    </div>
  );
});

export default BranchStockComparison;
